import type { MultipleChoiceValueType } from "../../../../shared-logic/features/filters/utils/constants/filterConfigConstants";
import { useCarFilterSelector } from "../../redux/store";

type UseFilterVisibilityReturnType = {
    isValueVisible: (val: MultipleChoiceValueType) => boolean;
    hasVisibleValues: (values: MultipleChoiceValueType[]) => boolean;
    shouldHideResultCount: boolean;
};

const useFilterVisibility = (): UseFilterVisibilityReturnType => {
    const hideZeroResultCountFilters = useCarFilterSelector(
        ({ carFilterSettings, carFilters }) => carFilterSettings.hideZeroResultCountFilters[carFilters.currentFilter],
    );
    const vehicleAggregationsActive = useCarFilterSelector(
        ({ carFilterSettings, carFilters }) => carFilterSettings.enableVehicleAggregations[carFilters.currentFilter],
    );
    const hideAllFilterCounts = useCarFilterSelector(
        ({ carFilterSettings, carFilters }) => carFilterSettings.hideAllFilterCounts[carFilters.currentFilter],
    );

    const shouldHideResultCount = vehicleAggregationsActive || hideAllFilterCounts;

    const isValueVisible = (val: MultipleChoiceValueType): boolean =>
        // !0 is true and !undefined is true, so don't show the filter if resultCount is 0 or undefined
        (!!val.resultCount || !hideZeroResultCountFilters) && (!shouldHideResultCount || val.resultCount !== 0);

    const hasVisibleValues = (values: MultipleChoiceValueType[]): boolean => values.some(isValueVisible);

    return { isValueVisible, hasVisibleValues, shouldHideResultCount };
};

export default useFilterVisibility;
